/**
 * OrbDocCoreConceptsPatternsSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsPatternsSLDocScreen
 */

import { useOrbDocCoreConceptsPatternsSLDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsPatternsSLDocScreenLogic';
import type { OrbDocCoreConceptsPatternsSLDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsPatternsSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsPatternsSLDocView as OrbDocCoreConceptsPatternsSLDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsPatternsSLDocBodyView } from '@/components/traits/OrbDocCoreConceptsPatternsSLDocBodyView';
import { OrbDocCoreConceptsPatternsSLDocFooterView } from '@/components/traits/OrbDocCoreConceptsPatternsSLDocFooterView';
import { OrbDocCoreConceptsPatternsSLDocHeaderView } from '@/components/traits/OrbDocCoreConceptsPatternsSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsPatternsSLDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsPatternsSLDocScreenConfig>;
}

export function OrbDocCoreConceptsPatternsSLDocScreenView({ config: propsConfig }: OrbDocCoreConceptsPatternsSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsPatternsSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsPatternsSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsPatternsSL" trait="OrbDocCoreConceptsPatternsSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsPatternsSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsPatternsSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsPatternsSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsPatternsSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsPatternsSLDocScreenView;
